// Fejl med en besked til brugeren (på dansk) og evt. fejl pr. felt. Bruges af appen, testversionen og serveren.
export class ApiFejl extends Error {
  constructor(public brugerBesked: string, public felter: Record<string, string> = {}) { super(brugerBesked); }
}
export const fejl = (tekst: string, felter: Record<string, string> = {}) => new ApiFejl(tekst, felter);
